import { ClockingBase } from "../json-schemas/base/clocking"
import { ClockingsCountPerScopeResponse } from "../json-schemas/serializers/clockings-count-per-scope-response"
import { ClockingsIndexResponse } from "../json-schemas/serializers/clockings-index-response"
import { EmployeeClockingsManualTodayResponse } from "../json-schemas/serializers/employee-clockings-manual-today-response"
import { httpGet, httpGetFormData, httpGetRoute, httpPatchMultipart, httpPostMultipart } from "../utils/http.service"
import { I18nService } from "../utils/i18n.service"
import type { RansackQuery as EventRansackQuery } from "./events.service"
import i18nScopedData from './clockings.service.yml'

export type RansackQuery = EventRansackQuery & {
  'q[customer_name_or_phone_number_or_email_or_customer_code_cont]'?: string
  'q[employee_name_or_phone_number_or_email_or_formatted_counter_cont]'?: string
}

export type ClockingMode = ClockingBase['clocking_mode']
export type ClockingType = ClockingBase['clocking_type']
export type ClockingParamsError = "customer_empty" | "employee_empty" | "not_your_customer" | "event_wrong_customer"

export const clockingClockGroupSessionSince = new Date(2026, 5, 1) // june
export const clockingAttachmentsAllowedExtentions = ['jpeg', 'jpg', 'png'] as const
export const clockingAttachmentsAllowedMimeTypes = ['image/jpeg', 'image/png'] as const
export const clockingAttachmentsMaxFilesCount = 10

const i18nScoped = new I18nService(i18nScopedData)

export function clockingList (query: RansackQuery = {}): Promise<ClockingsIndexResponse> {
  return httpGet(`/${httpGetRoute()}/clockings`, query)
}

export function clockingCountPerScope (query: RansackQuery = {}): Promise<ClockingsCountPerScopeResponse> {
  return httpGet(`/${httpGetRoute()}/clockings/count_per_scope`, query)
}

export function clockingCreateManual (body: any) {
  return httpPostMultipart(`/${httpGetRoute()}/events/${body.event_id}/clocking`, httpGetFormData({ clocking: body }))
}

export function clockingCreateWithToken (body: any, token: string) {
  return httpPostMultipart(`/${httpGetRoute()}/customers/${token}/clockings`, httpGetFormData({ clocking: body }))
}

export function clockingManualToday (): Promise<EmployeeClockingsManualTodayResponse> {
  return httpGet(`/${httpGetRoute()}/clockings/manual_today`)
}

export function clockingUpdate (body: any) {
  return httpPatchMultipart(`/${httpGetRoute()}/clockings/${body.id}`, httpGetFormData({ clocking: body }))
}

export function clockingCheckFiles (files: File[], existingFileCount: number) {
  const validExtRegex = new RegExp(clockingAttachmentsAllowedExtentions.map(_ => '\\.' + _).join('|') + '$')
  const anyInvalidExt = files.find(file => !file.name.toLocaleLowerCase().match(validExtRegex))
  if (anyInvalidExt) return alert(i18nScoped.t('unsupported_file_extension', { ext: anyInvalidExt.name.split('.').pop().toUpperCase() }))

  if (existingFileCount + files.length > clockingAttachmentsMaxFilesCount) return alert(i18nScoped.t('max_files_count_reached', { count: clockingAttachmentsMaxFilesCount }))
  return true
}

export function clockingI18nMode (mode: ClockingMode) {
  return i18nScoped.t(`clocking_mode.${mode}`)
}

export function clockingI18nType (type: ClockingType) {
  return i18nScoped.t(`clocking_type.${type}`)
}

